import React from 'react';
import { ApButtonIcon, ApMenu, ApMenuItem } from '@alixpartners/ui-components';

import { MenuSection } from './styles';

export const TreeMenu = ({ onSelect, options }) => {
	const renderOption = option => {
		return (
			<ApMenuItem key={option.value} onClick={() => onSelect(option.value)}>
				{option.label}
			</ApMenuItem>
		);
	};
	return (
		<ApMenu
			button={<ApButtonIcon iconName="more_horiz" />}
			placement="bottom-end"
		>
			{options.map(
				(option, index) =>
					Array.isArray(option) ? (
						<MenuSection key={index}>
							{option.map(sectionOption => renderOption(sectionOption))}
						</MenuSection>
					) : (
						renderOption(option)
					)
			)}
		</ApMenu>
	);
};

export default TreeMenu;
